import * as Msdyn365 from '@msdyn365-commerce/core';
import { ensureAuthenticated } from '../../utilities/is-authenticated';
import { trackedAction } from '../../utilities/track-execution-time';
import { IGetTDSDocumentItem } from './get-tds-document.action';

/**
 * GetDocumentDownload Input Action
 */
export class GetDataSheetDocumentDownloadInput implements Msdyn365.IActionInput {
    public document: IGetTDSDocumentItem;
    constructor(document: IGetTDSDocumentItem) {
        this.document = document;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetDataSheetDocumentDownload-${this.document.DocumentId}`;
    public getCacheObjectType = () => 'GetDataSheetDocumentDownload';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetDataSheetDocumentDownloadData {
    '@odata.context'?: string;
    FileName: string;
    Length: string;
    Type: string;
    Value: string;
    Content: string;
    RecordCreatedDate: Date;
    ExtensionProperties: unknown[];
}

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetDataSheetDocumentDownloadInput({} as IGetTDSDocumentItem);
};

async function action(input: GetDataSheetDocumentDownloadInput, ctx: Msdyn365.IActionContext): Promise<IGetDataSheetDocumentDownloadData> {
    ensureAuthenticated(ctx);
    let getDocumentDownloadData: IGetDataSheetDocumentDownloadData = {} as IGetDataSheetDocumentDownloadData;

    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/Document/Download(documentId='${input.document.DocumentId}',downstreamSystem='${input.document.DownstreamSystem}')`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    )
        .then(res => {
            getDocumentDownloadData = res?.data as IGetDataSheetDocumentDownloadData;
        })
        .catch(error => {
            return { error: { errorCode: error.response.status, errorText: error.response.statusText } };
        });
    return getDocumentDownloadData;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetDataSheetDocumentDownloadData>>(
        ((input, ctx) => trackedAction(action, input, ctx, 'GetDataSheetDocumentDownload'))
    ),
    id: 'GetDataSheetDocumentDownload',
    input: createInput
});
